<template>
  <v-container class="not-authorized">
    <h1 class="not-authorized__title">Hey now!</h1>
    <p>
      you do not belong here.
    </p>
  </v-container>
</template>

<script>
export default {
  name: 'NotAuthorized'
}
</script>

<style lang="scss">
.not-authorized {
  &__title {
    margin-bottom: 25px;
  }
}
</style>
